import { render } from "./PrivatePolicy.vue?vue&type=template&id=03b0a94a&scoped=true"
import script from "./PrivatePolicy.vue?vue&type=script&lang=js"
export * from "./PrivatePolicy.vue?vue&type=script&lang=js"

import "./PrivatePolicy.vue?vue&type=style&index=0&id=03b0a94a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b0a94a"]])

export default __exports__